import React from 'react';

const Body = () => <></>;

export const content = {
    image: '',
    body: Body,
};
